module.exports = __webpack_public_path__ + "static/media/dai-multi-collateral-mcd.34752d01.webp";